import apiClient from './apiClient';

const profileService = {
  async getAvailableProfiles() {
    try {
      const response = await apiClient.get('/api/ProfileManagement/available');
      return response.data;
    } catch (error) {
      console.error('Failed to fetch available profiles', error);
      throw error;
    }
  },

  async selectProfile(profileId) {
    try {
      const response = await apiClient.post(`/api/ProfileManagement/select/${profileId}`);
      return response.data;
    } catch (error) {
      console.error(`Failed to select profile with ID ${profileId}`, error);
      throw error;
    }
  },

  async getCurrentSession() {
    try {
      const response = await apiClient.get('/api/ProfileManagement/current');
      return response.data;
    } catch (error) {
      console.error('Failed to fetch current session', error);
      throw error;
    }
  },
};

export default profileService;
